import { QP_QUERY_URI } from '@constants/config';

/**
 * Execute GQL directly, outside of the context of Apllo. Used
 * where requests are required form vanilla JS/TS contexts, for
 * example auth clients.
 *
 * @param {string} query - The GraphQL query string to execute.
 * @param {TVariables} variables - Optional variables for the query.
 * @param {string} token - Optional authorization token.
 */
export const execute = async <TResult, TVariables = void>(
  query: string,
  variables?: TVariables,
  token?: string
) => {
  const response = await fetch(QP_QUERY_URI as string, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/graphql-response+json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (!response.ok) {
    // TODO better error handling
    throw new Error('Query error');
  }

  return response.json() as TResult;
};
